import React, { Children } from 'react';
import { motion } from 'framer-motion'

const AnimatedHeading = ({Children, className, duration}) => {
    return (
        <motion.p
            className={className}
            initial={{ opacity: 0, y: 0 }} // Initial state of the heading
            animate={{ opacity: 1, y: 0 }} // Final state of the heading
            transition={{ duration: duration }} // Animation duration
            style={{'line-height':'1.7'}}
        >
            <p id='message'>{Children}</p>
        </motion.p>
    );
}

export default AnimatedHeading;
